import { LocationAddressV1 } from '@csp/dmdp-api-appointment-dto';

export type VisitAddress = {
  lines: Array<string>;
  city?: string;
  district?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};

const from = ({ city, country, district, lines, postalCode, state }: LocationAddressV1): VisitAddress => ({
  city,
  country,
  district,
  lines: lines ?? [],
  postalCode,
  state,
});

export const VisitAddress = {
  from,
};
